import { motion } from 'framer-motion';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Button } from '@bonusly/design-system';
import { useFeatureFlag, Variant } from '@bonusly/who-am-i';

import { Bizy } from '../../../../components/bizy';
import { useBizySidePanelStore } from '../../../../components/bizy-side-panel/store/use-bizy-side-panel-store';

export const AskBizyButton: FC = () => {
	const { t } = useTranslation('vertical_navbar');
	const isEnabled = useFeatureFlag(Variant.BizyForParticipation);
	const isOpen = useBizySidePanelStore((s) => s.isOpen);
	const toggle = useBizySidePanelStore((s) => s.toggle);

	if (!isEnabled) return null;

	return (
		<motion.div
			initial={false}
			animate={{ height: isOpen ? 0 : 'auto', opacity: isOpen ? 0 : 1 }}
			transition={{ duration: 0.35, ease: [0.4, 0, 0.2, 1] }}
			style={{ overflow: 'hidden' }}
		>
			<Box pt={3}>
				<Button
					colorScheme="secondary"
					variant="ghost"
					borderRadius="sm"
					h="auto"
					w="100%"
					py={1}
					px={2}
					fontSize={50}
					fontWeight="medium"
					display="flex"
					alignItems="center"
					justifyContent="flex-start"
					gap={2}
					onClick={() => toggle()}
					data-testid="ask-bizy-button"
					_hover={{ bg: 'secondary.bgAlpha' }}
				>
					<Bizy state="curious" size={32} />
					{t('admin_menu.ask_bizy')}
				</Button>
			</Box>
		</motion.div>
	);
};
